import { createAction } from 'redux-actions';
import * as types from './details-constants';

export const getOrderDetailsRequest = createAction(types.GET_ORDER_DETAILS_REQUEST);
export const getOrderDetailsSuccess = createAction(types.GET_ORDER_DETAILS_SUCCESS);
export const getOrderDetailsFailure = createAction(types.GET_ORDER_DETAILS_FAILURE);

export const getOrderDetailsStatusRequest = createAction(types.GET_ORDER_DETAILS_STATUS_REQUEST);
export const getOrderDetailsStatusSuccess = createAction(types.GET_ORDER_DETAILS_STATUS_SUCCES);

export const saveOrderRequest = createAction(types.SAVE_ORDER_REQUEST);
export const saveOrderSuccess = createAction(types.SAVE_ORDER_SUCCESS);
export const saveOrderFailure = createAction(types.SAVE_ORDER_FAILURE);

export const addSubOrderRequest = createAction(types.ADD_SUBORDER_REQUEST);
export const addSubOrderSuccess = createAction(types.ADD_SUBORDER_SUCCESS);
export const addSubOrderFailure = createAction(types.ADD_SUBORDER_FAILURE);

export const getLinkedPlanningsRequest = createAction(types.GET_LINKED_PLANNINGS_REQUEST);
export const getLinkedPlanningsSuccess = createAction(types.GET_LINKED_PLANNINGS_SUCCESS);
export const getLinkedPlanningsFailure = createAction(types.GET_LINKED_PLANNINGS_FAILURE);

export const externalRemove = createAction(types.EXTERNAL_REMOVE);

export const planningUpdateOrderSocketEvents =
    createAction(types.PLANNING_UPDATE_ORDER_SOCKET_EVENTS);
export const planningUpdateOrderSocketEventsSuccess =
    createAction(types.PLANNING_UPDATE_ORDER_SOCKET_EVENTS_SUCCESS);
export const planningUpdateOrderSocketEventsFailure =
    createAction(types.PLANNING_UPDATE_ORDER_SOCKET_EVENTS_FAILURE);

export const resetWipCodesChanged = createAction(types.RESET_WIPCODES_CHANGED);
